import axios from "axios";

const apiInstance = axios.create({
  baseURL: process.env.LOCAL_API_URL + "api",
  withCredentials: false,
});

export default apiInstance;
